export const analysisDe = {
  title: 'Analyse- und Nährwertprofile',
  subtitle:
    'Versionierte Labor- und Rechenwerte mit Herkunftsnachweis, kontrolliertem Vorrang und Freigabe.',
  help: { open: 'Hilfe zu Analysewerten, Berechnung und Freigabe öffnen' },
  pagination: 'Seite {{page}} von {{pages}} · {{total}} Versionen',
  actions: {
    parameters: 'Analyseparameter',
    newParameter: 'Neuer Parameter',
    newLaboratory: 'Laborprofil erfassen',
    calculate: 'Rezeptur berechnen',
    addValue: 'Wert hinzufügen',
    submit: 'Zur Prüfung',
    review: 'Fachlich prüfen',
    approve: 'Freigeben',
    copy: 'Neue Version',
    archive: 'Archivieren',
    history: 'Versionshistorie',
  },
  filters: {
    searchProfiles: 'Nummer, Artikel oder Rezeptur suchen',
    searchParameters: 'Schlüssel oder Bezeichnung suchen',
    domain: 'Domäne, z. B. NUTRITION',
    allStatuses: 'Alle Status',
    allOrigins: 'Alle Quellenarten',
  },
  statuses: {
    DRAFT: 'Entwurf',
    IN_REVIEW: 'In Prüfung',
    APPROVED: 'Freigegeben',
    SUPERSEDED: 'Ersetzt',
    ARCHIVED: 'Archiviert',
  },
  origins: { ANALYZED: 'Analysiert', CALCULATED: 'Berechnet', MIXED: 'Laborwert mit Vorrang' },
  targetTypes: { PRODUCT: 'Artikel', RECIPE: 'Rezeptur' },
  issueSeverity: { ERROR: 'Fehler', WARNING: 'Warnung' },
  aggregationModes: {
    MASS_BALANCE: 'Massenbilanz / additive Menge',
    WEIGHTED_AVERAGE: 'Gewichteter Mittelwert',
    NOT_CALCULABLE: 'Nicht automatisch berechenbar',
  },
  roundingModes: { HALF_UP: 'Kaufmännisch', DOWN: 'Abschneiden', UP: 'Vom Nullpunkt weg' },
  columns: {
    number: 'Nummer',
    target: 'Artikel / Rezeptur',
    domain: 'Domäne',
    origin: 'Herkunft',
    reference: 'Bezugsmenge',
    version: 'Version',
    status: 'Status',
    issues: 'Fehler / Warnungen',
    key: 'Schlüssel',
    name: 'Bezeichnung',
    parameter: 'Parameter',
    effective: 'Freigabewert',
    calculated: 'Berechnet',
    analyzed: 'Analysiert',
    range: 'Min / Ziel / Max / Toleranz',
    difference: 'Differenz',
    hash: 'Snapshot-Hash',
    created: 'Erstellt',
    validity: 'Gültigkeit',
  },
  fields: {
    key: 'Stabiler Schlüssel',
    domain: 'Konfigurierbare Domäne',
    defaultUnit: 'Werteinheit',
    reference: 'Bezugsmenge und -einheit',
    referenceQuantity: 'Bezugsmenge',
    referenceUnit: 'Bezugseinheit',
    aggregation: 'Berechnungsart',
    retention: 'Erhaltungs-/Retentionsfaktor',
    rounding: 'Nachkommastellen / Rundung',
    metadata: 'Konfigurierbare Metadaten (JSON)',
    changeReason: 'Änderungsgrund',
    validFrom: 'Gültig ab',
    validTo: 'Gültig bis',
    name: 'Bezeichnung',
    shortName: 'Kurzbezeichnung',
    description: 'Beschreibung',
    reason: 'Begründung / Prüfvermerk',
    number: 'Profilnummer',
    numberFirst: 'Profilnummer (nur beim ersten Stand)',
    targetType: 'Zielart',
    target: 'Ziel',
    source: 'Quelle / Labor / Bericht',
    method: 'Messmethode',
    sampledAt: 'Probenahme / Messzeitpunkt',
    recipe: 'Freigegebene Rezepturversion',
    laboratoryOverride: 'Freigegebener Laborstand mit kontrolliertem Vorrang',
    overrideReason: 'Begründung für den Laborvorrang',
    parameter: 'Analyseparameter',
    value: 'Wert',
    unitCode: 'Einheit',
    minValue: 'Minimum',
    maxValue: 'Maximum',
    targetValue: 'Zielwert',
    toleranceValue: 'Toleranz',
  },
  parameters: {
    title: 'Konfigurierbare Analyseparameter',
    subtitle:
      'Branchenneutrale Parameter; Nährwerte entstehen ausschließlich über konfigurierbare Domänen.',
    createTitle: 'Analyseparameter anlegen',
    editTitle: 'Analyseparameter v{{version}} bearbeiten',
    editorHelp:
      'Vor der Prüfung müssen alle Sprachen vollständig sein. Einheiten, Retention und Rundung steuern reproduzierbare Serverberechnungen.',
    historyTitle: 'Versionshistorie des Analyseparameters',
  },
  calculate: {
    title: 'Analysewerte aus Rezeptur berechnen',
    description:
      'Löst Unterrezepturen auf und berücksichtigt Mengen, Verluste, Ausbeute, Aufnahme, Retention und Rundungsregeln.',
    noOverride: 'Nur berechnete Werte verwenden',
    reviewWarning:
      'Das Ergebnis ist ein prüfpflichtiger Entwurf. Fehlende oder veraltete Quellen werden nicht stillschweigend ersetzt.',
  },
  laboratory: {
    title: 'Analysiertes Profil erfassen',
    description:
      'Manuelle Werte benötigen eine nachvollziehbare Quelle. Prüfberichte werden anschließend ausschließlich in der geschützten DMS-Akte hochgeladen.',
    values: 'Mess- und Analysewerte',
    valueHelp: 'Minimum, Maximum, Ziel und Toleranz sind optional; Wert und Einheit sind Pflicht.',
    dmsHelp:
      'Nach dem Anlegen im Profil DMS-Prüfberichte hochladen, im Entwurf auswählen und gemeinsam mit dem Hash snapshotten.',
    editTitle: 'Analysierten Entwurf bearbeiten',
    editDescription:
      'Werte und DMS-Auswahl werden optimistisch gesperrt. Nach Einreichung bleibt der Inhalt unveränderlich.',
  },
  review: {
    title: 'Fachliche Prüfung erforderlich',
    description:
      'Berechnete und priorisierte Laborwerte sind keine automatische fachliche oder rechtliche Freigabe. Quellen, Warnungen und Abweichungen müssen geprüft werden.',
  },
  sections: {
    values: 'Freigabe-, Rechen- und Laborwerte',
    valuesHelp:
      'Der Freigabewert ist der wirksame Snapshot-Wert. Bei MIXED bleibt der Rechenwert zum Vergleich erhalten.',
  },
  summary: {
    reference: 'Bezugsmenge',
    values: 'Parameter',
    errors: 'Fehler',
    warnings: 'Warnungen',
    validity: 'Gültigkeit',
  },
  tabs: {
    values: 'Werte',
    sources: 'Herkunft',
    validation: 'Validierung',
    comparison: 'Vergleich',
    documents: 'Prüfberichte',
    history: 'Versionen',
    snapshot: 'Snapshot',
  },
  sources: {
    manual: 'Manuell erfasster oder laboranalysierter Wert',
    noCalculated: 'Für diesen Wert gibt es keine automatisch berechneten Rohstoffbeiträge.',
  },
  comparison: {
    title: 'Versionen und Labor-/Rechenwerte vergleichen',
    description:
      'Werte werden in kompatible Einheiten normiert und als exakte Dezimaldifferenz gezeigt.',
  },
  documents: {
    title: 'Geschützte Labor- und Prüfberichte',
    snapshotSelection: 'Dokumente für diesen Entwurf snapshotten',
    snapshotHelp:
      'Nur ausgewählte Dateien und ihre SHA-256-Hashes werden Bestandteil dieser Profilversion.',
  },
  history: {
    title: 'Unveränderliche Versionshistorie',
    description: 'Freigegebene Stände bleiben trotz späterer Quelländerungen reproduzierbar.',
  },
  snapshot: { sources: 'Quellen-Snapshot', calculation: 'Berechnungs-Snapshot' },
  states: {
    loading: 'Analysewerte werden geladen …',
    noProfiles: 'Keine Analyseprofilversion entspricht den Filtern.',
    noParameters: 'Keine Analyseparameterversion entspricht den Filtern.',
    noIssues: 'Keine Validierungsfehler oder Warnungen vorhanden.',
    notFound: 'Die Analyseprofilversion wurde nicht gefunden.',
  },
  messages: {
    saved: 'Analyseentwurf gespeichert.',
    created: 'Laborprofil angelegt.',
    calculated: 'Reproduzierbarer Berechnungsentwurf erzeugt.',
    workflow: 'Analyseworkflow aktualisiert.',
  },
  workflow: {
    REVIEW: {
      title: 'Fachprüfung dokumentieren',
      description: 'Die prüfende Person muss unabhängig von Ersteller und Einreicher sein.',
    },
    APPROVE: {
      title: 'Analyseprofil freigeben',
      description: 'Die Freigabe friert Werte, Quellen, Regeln, Dokument-Hashes und Warnungen ein.',
    },
    COPY: {
      title: 'Analysierte Version kopieren',
      description: 'Es entsteht ein neuer bearbeitbarer Entwurf mit vollständiger Herkunft.',
    },
    ARCHIVE: {
      title: 'Analyseversion archivieren',
      description: 'Der revisionssichere Stand bleibt lesbar und wird nicht mehr aktiv verwendet.',
    },
  },
} as const;
